import React, { Component } from 'react';
import BrandingForm from '../components/BrandingForm';
import { connect } from 'react-redux';
import { 
  changeBackground, 
  changeTopLogo, 
  changeBottomLogo, 
  removeBackground,
  removeTopLogo,
  removeBottomLogo,
 } from '../redux/actions/organizationActions';
import UploadingFilesProgress from "../containers/UploadingFilesProgress";

export class brandingPage extends Component {
 
  render() {
    const { 
      organizations, 
      curentUser, 
      changeBackground, 
      changeTopLogo, 
      changeBottomLogo, 
      uploading, 
      uploadingTitle,
      removeBackground,
      removeTopLogo,
      removeBottomLogo
    } = this.props;
    const orgKey = curentUser.organizationRef.id;
    
    if(!organizations[orgKey])return(<div/>);

    const {background, topLogo, bottomLogo} = organizations[orgKey];
    return (
      <div>
        {uploading && <UploadingFilesProgress title={uploadingTitle} />}
        <BrandingForm
          background={background}
          onBackgroundChange={image => changeBackground({image, orgKey})}
          topLogo={topLogo}
          onTopLogoChange={image => changeTopLogo({image, orgKey})}
          bottomLogo={bottomLogo}
          onBottomLogoChange={image => changeBottomLogo({image, orgKey})}
          onRemoveBackground={() => removeBackground({orgKey})}
          onRemoveTopLogo={() => removeTopLogo({orgKey})}
          onRemoveBottomLogo={() => removeBottomLogo({orgKey})}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  curentUser: state.user.user,
  organizations: state.data.organizations,
  uploading: state.ui.uploading,
  uploadingTitle: state.ui.uploadingTitle,
});

const mapDispatchToProps = {
  changeBackground,
  changeTopLogo,
  changeBottomLogo,
  removeBackground,
  removeTopLogo,
  removeBottomLogo
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(brandingPage);
